import React, { useRef } from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";
import ReactToPdf from "react-to-pdf";
import { Grid } from "@material-ui/core";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import ReactToPrint from "react-to-print";
import MapLink from "../../assets/map.pdf";

const SocietyMaps = () => {
  const componentRef = useRef();
  const ref = React.createRef();
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("society-maps-page");
    return function cleanup() {
      document.body.classList.remove("society-maps-page");
    };
  });
  return (
    <>
      <ExamplesNavbar notHome={true} />

      
      <div style={{ marginBottom: 50 }}></div>

      <Grid 
        
        style={{ width: "100%",  backgroundColor:"#3e3c3d" }}
      >
         <h2
              className="title my-3 text-white"
              style={{ width: "100%" }}
            >
              Payment Plan
          </h2>
          <a a href={'/paymentplan/myfile.pdf'} target="_blank" rel="noopener noreferrer" download>
          <button style={{backgroundColor:'#7b7b7b', color:'white', borderRadius:10, height:35, width:90}}>
          
          Download
    
            </button>
    
          
            </a> 
    
       
      </Grid>
{/*
      <Grid container direction="column" alignItems="center">
        <div style={{ width: 800, height: 1000 }}>
          <Grid container direction="row" ref={ref}>
           
            <Grid item md={3} xs={3} lg={3} xl={3}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                style={{ height: "50%" }}
              >
                <img
                  src={require("assets/img/map-legend@2x.png")}
                  // className="d-lg-none d-md-none d-block"
                />
              </Grid>
            </Grid>
            <Grid item md={9} xs={9} lg={9} xl={9}>
              <img
                // className="project-map"
                style={{ width: 600, height: 1000 }}
                src={require("assets/img/map.png")}
              />
            </Grid>
          </Grid>
        </div>
</Grid>*/}
<img
                // className="project-map"
                style={{ width: 400, height: 400 }}
                src={require("assets/img/map.png")}
              />
    <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
        </div>
         
          { <DemoFooter/> }
    </>
  );
};

export default SocietyMaps;
